<template>
  <div class="filterMenu bg-white overflow-x-scroll border-link border-opacity-20 border-t-2 scrollbar">
    <ul class="whitespace-nowrap my-2 pl-4 flex">
      <li v-for="genre in genres" v-bind:key="genre.id" class="w-16 text-center" :class="{ 'flex-1': genres.length < 6 }" >
        <div v-bind:class="{ 'hidden': !genre.filter }" @click="onToggle(genre)" class="flex flex-col justify-center w-16">
          <div v-if="icon(genre) !== undefined" class="flex justify-center">
            <img :src="icon(genre)" class="h-6 w-8">
          </div>
          <div v-else class="mx-auto w-8">
            <svg viewBox="0 0 24 24" class="fill-current text-supplement h-6 w-8" xmlns="http://www.w3.org/2000/svg"><path d="m11.4590061.00716341c-.6729013.06771385-.9557149.11366253-1.4384485.23941682-2.07965507.53687407-3.81066928 1.92984464-4.77369831 3.84517917-.72897641 1.45101101-.93864855 3.2284995-.56562718 4.77624458.18529166.76419913.40227795 1.26721632 1.0069139 2.34580112.65583496 1.1704822.76798518 1.3518586 1.91874392 3.1075819.27062335.4111198.62414033.9552489.78505151 1.2091759 1.87242096 2.9358789 2.96954266 5.4896583 3.59368306 8.3650784.0365707.1644479.0438848.1499378.1072741-.1547745.253557-1.2672163.7923656-2.9165321 1.3848114-4.2442072.7362905-1.6493158 1.4920854-2.9673175 3.0719407-5.3542306 1.0971216-1.663826 1.3799352-2.1329862 1.9284961-3.2188261.6168262-1.21401254.7411666-1.53807166.9020778-2.32161761.1682253-.82223957.1584731-1.8718042-.0243805-2.78110443-.2803755-1.39055222-1.0166661-2.70855389-2.0967214-3.75086346-1.1483207-1.10518672-2.628216-1.7968353-4.3250975-2.0169053-.2876897-.03627528-1.2580329-.06771385-1.4750191-.04594869z" transform="matrix(-1 0 0 1 24 0)"/></svg>
          </div>
          <p class="mt-1 text-xs text-center leading-none whitespace-normal">
            <span :class="isOn(genre) ? '' : 'text-supplement'">{{ genre.filterName }}</span>
          </p>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      genres: 'genres/getAllForFilter'
    })
  },
  data () {
    return {
      mobakuMessage: false
    }
  },
  methods: {
    onToggle: function (genre) {
      if (this.isOn(genre)) {
        this.$store.dispatch('user/offFilter', genre)
        if (genre.id == "mobaku") {
          this.$store.dispatch('googleMap/offDocomoMobaku')
          this.mobakuMessage = false
        }
      } else {
        this.$store.dispatch('user/onFilter', genre)
        if (genre.id == "mobaku") {
          this.$store.dispatch('googleMap/onDocomoMobaku')
          if(!this.mobakuMessage){
            this.mobakuMessage = true
            this.$store.dispatch('map/setShowDocomoMobaku', true)
          }
        }
      }
    },
    isOn: function (genre) {
      return this.$store.getters['user/isFilterOn'](genre)
    },
    icon: function (genre) {
      return this.iconPath(genre)
    },
    iconPath(genre) {
      return require('@/assets/images/filter/' + genre.id + (this.isOn(genre) ? '_on' : '_off') + '.svg')
    }
  }
}
</script>
